import React from "react"

import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"

import "./DoubleImage.scss"

const DoubleImage = ({ section }) => {
  return (
    <section className="double-image">
      <Fade>
        <figure className="double-image__first">
          <img
            src={
              section.image1?.url ||
              "https://images.unsplash.com/photo-1504297050568-910d24c426d3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHw2fHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60"
            }
            alt={section.image1?.alt}
            loading="lazy"
          />
          {section.image1?.caption && (
            <figcaption>{section.image1?.caption}</figcaption>
          )}
        </figure>
      </Fade>
      <Fade>
        <figure className="double-image__second">
          <img
            src={
              section.image2?.url ||
              "https://images.unsplash.com/photo-1640622659144-18a1fd885123?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHwxfHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60"
            }
            alt={section.image2?.alt}
            loading="lazy"
          />
          {section.image2?.caption && (
            <figcaption>{section.image2?.caption}</figcaption>
          )}
        </figure>
      </Fade>
    </section>
  )
}

DoubleImage.propTypes = {
  section: PropTypes.object.isRequired,
}

export default DoubleImage
